// https://www.youtube.com/watch?v=ivtbRBEjLW8&t=368s
// 16.42 хв
import { initializeApp } from 'firebase/app';
import {
  doc,
  updateDoc,
  getFirestore,
  getDoc,
  getDocs,
  query,
  where,
  orderBy,
  limit,
  collection,
  onSnapshot,
  addDoc,
  setDoc,
  arrayUnion,
  arrayRemove,
  deleteDoc,
  deleteField,
} from 'firebase/firestore';
import { generateRandomString } from './helper';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKED,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_API_ID,
};

export const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

// =====================================================================

// Додає меню
export const addMenuBd = async (group_id, menuObject, groupName) => {
  try {
    // ---------- Додаєм меню -----------------
    const menuGrroupRef = doc(db, 'menu', group_id);
    const path = 'menu.' + menuObject.id;

    console.log('path === ', path);
    console.log('menuObject === ', menuObject);

    await updateDoc(menuGrroupRef, {
      [path]: menuObject,
    });
    // ---------- /Додаєм меню -----------------

    // ---------- Додаєм історію ----------------
    const menuHistoryRef = doc(db, 'menuHistory', menuObject.menu_history_id);
    const menuHistoryInfo = {
      group_id: group_id,
      groupName: groupName,
      id: new Date().getTime(),
      date: new Date().toLocaleDateString(), //дата в формате 27.07.2022 ', new Date().toLocaleDateString()
      time: new Date().toLocaleTimeString(), //час в формате 13:54:43', new Date().toLocaleTimeString()
      day: new Date().getDay(), // возвращает день недели new Date().getDay();
    };
    setDoc(menuHistoryRef, { [menuObject.id]: menuHistoryInfo }, { merge: true });

    // ---------- /Додаєм історію ----------------

    // alert('Меню додано успішно.');
    return true;
  } catch {
    alert('Не вдалося додати меню.');

    return false;
  }
};
// Отримуєм меню з BD
export const getMenuGrupDb = async (colectionName, document) => {
  const docRef = doc(db, colectionName, document);

  try {
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      return docSnap.data().menu;
    } else {
      return [];
    }
  } catch {
    return 'error';
  }
};

// -------------- /Отримує історію меню ------------------------
export const getHistoryMenuBd = async (colection, document) => {
  const docRef = doc(db, colection, document);
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    return docSnap.data();
  } else {
    return {};
  }
};
// -------------- Отримує історію меню ------------------------
// Видаляє меню
export const removeMenuBd = async (group_id, indexRenderMenuDey, menuDay) => {
  // --------- Видаляє з меню ---------
  const menuRef = doc(db, 'menu', group_id);
  const menuPath = 'menu.' + indexRenderMenuDey;

  await updateDoc(menuRef, {
    [menuPath]: deleteField(),
  });
  // --------- /Видаляє з меню ---------

  // --------- Видаляє з історії ---------
  const menuHistory = await getHistoryMenuBd('menuHistory', menuDay.menu_history_id);

  if (Object.keys(menuHistory).length > 1) {
    const historyMenuRef = doc(db, 'menuHistory', menuDay.menu_history_id);
    const historyPath = menuDay.id;

    await updateDoc(historyMenuRef, {
      [historyPath]: deleteField(),
    });
  } else {
    await deleteDoc(doc(db, 'menuHistory', menuDay.menu_history_id));
  }
  // --------- /Видаляє з історії -------------------
};

// ========================================================================
// -------------- Додає клієнта і користувача ------------------------
// Додає користувача
const addUser = async (data) => {
  const userData = {
    name: data.name,
    surname: data.surname,
    fullName: data.fullName,
    user_id: data.client_id,
    participationGroups: {},
    accessMeasurements: {},
  };

  try {
    await setDoc(doc(db, 'users', data.client_id), userData);
    return true;
  } catch (e) {
    return false;
  }
};
const addUserMeasurements = async (data) => {
  const userMeasurements = {
    client_id: data.client_id,
    name: data.name,
    surname: data.surname,
    fullName: data.fullName,
    time_milliseconds: data.time_milliseconds,
    date_time: data.date_time,
    date_day: data.date_day,
    date: data.date,
    measurements: [],
  };

  try {
    await setDoc(doc(db, 'measurements', data.client_id), userMeasurements);
    return true;
  } catch (e) {
    alert('Не вдалося додати заміри.');
    return false;
  }
};
const addLoginWebCounter = async (data) => {
  const userMeasurements = {
    client_id: data.client_id,
    name: data.name,
    surname: data.surname,
    fullName: data.fullName,

    time_milliseconds: data.time_milliseconds,
    date_time: data.date_time,
    date_day: data.date_day,
    date: data.date,

    groupMember: [], //до яких груп має доступ

    counterAll: 0, //Рахує всі перегляди програми (буде обнулятись)
    counterAllTime: 0, //Рахує всі перегляди програми
    counterAllTimeGroup: 0, //Рахує всі перегляди програми (буде обнулятись одєльно )

    counterIos: 0,
    counterAndroid: 0,
    counterWindows: 0,
    counterOther: 0,
    timeViewMilliseconds: 0,
    timeViewMillisecondsAllTime: 0,
    timeViewMillisecondsGropTime: 0,
  };

  try {
    await setDoc(doc(db, 'loginWebCounter', data.client_id), userMeasurements);
    return true;
  } catch (e) {
    alert('Не вдалося додати loginWebCounter.');
    return false;
  }
};

// Додає клієнта і користувача
export const addClientBd = async (clientData) => {
  // Додає користувача
  const isAddUser = await addUser(clientData);
  // Додає користувача
  const isAddMeasurements = await addUserMeasurements(clientData);
  const isAddLoginWebCounter = await addLoginWebCounter(clientData);

  // Якщо користувача додали успішно додаєм клієнта
  if (isAddUser && isAddMeasurements && isAddLoginWebCounter) {
    try {
      await setDoc(doc(db, 'clients', clientData.client_id), clientData);
      return true;
    } catch (e) {
      await deleteDoc(doc(db, 'users', clientData.client_id));
      await deleteDoc(doc(db, 'measurements', clientData.client_id));
      await deleteDoc(doc(db, 'loginWebCounter', clientData.client_id));
      alert('Не вдолося додати клієнта.');
      return false;
    }
  } else {
    await deleteDoc(doc(db, 'users', clientData.client_id));
    await deleteDoc(doc(db, 'measurements', clientData.client_id));
    await deleteDoc(doc(db, 'loginWebCounter', clientData.client_id));
    alert('Не вдолося додати клієнта.');
    return false;
  }
};

// -------------- Видаляє клієнта і користувача ------------------------
export const deleteClientBd = async (client_id) => {
  try {
    await deleteDoc(doc(db, 'clients', client_id));
    await deleteDoc(doc(db, 'users', client_id));
    await deleteDoc(doc(db, 'measurements', client_id));
    await deleteDoc(doc(db, 'loginWebCounter', client_id));
    await deleteDoc(doc(db, 'loginWebList', client_id));
    await deleteDoc(doc(db, 'measurements', client_id));
    return true;
  } catch (e) {
    return false;
  }
};
// -------------- Видаляє дані клієнта з loginWebList ------------------------
export const deleteLoginWebListItemBd = async (client_id) => {
  try {
    await deleteDoc(doc(db, 'loginWebList', client_id));
    return true;
  } catch (e) {
    return false;
  }
};
// -------------- Міняє дані клієнта в loginWebCounter ------------------------
export const editsLoginWebCounterBd = async (client_id, updateObject) => {
  try {
    await updateDoc(doc(db, 'loginWebCounter', client_id), updateObject);

    return true;
  } catch {
    alert('Не вдалося змінити дані.');
    return false;
  }
};

// =======================================================================
// -------------- Додає Групу (і пустий шабон меню) ------------------------
export const addGroupBd = async (data) => {
  try {
    await setDoc(doc(db, 'groupsList', data.group_id), data);
    await setDoc(doc(db, 'menu', data.group_id), { menu: {} });

    return true;
  } catch (e) {
    alert('Не вдалося створити групу.');
    return false;
  }
};
// -------------- /Додає Групу (і пустий шабон меню)------------------------

// -------------- Отримує список всіх груп ------------------------
export const getGrupListDb = async (
  colectionName = 'groupsList',
  getOrderBy = 'time_milliseconds',
) => {
  const body = query(
    collection(db, colectionName),
    // orderBy(getOrderBy),
    orderBy(getOrderBy, 'desc'),
  );

  const grupListBdArray = await getDocs(body);

  const grupListArray = [];
  grupListBdArray.forEach((doc) => {
    grupListArray.push(doc.data());
  });

  return grupListArray;
};
// -------------- /Отримує список всіх груп ------------------------

// -------------- Отримує список всіх груп ------------------------
export const getMeasurementsDb = async () => {
  const body = query(
    collection(db, 'measurements'),
    orderBy('fullName'),
    // orderBy(getOrderBy, 'desc'),
  );

  const measurementsListBdArray = await getDocs(body);

  const measurementsListArray = [];
  measurementsListBdArray.forEach((doc) => {
    measurementsListArray.push(doc.data());
  });

  return measurementsListArray;
};
// -------------- /Отримує список всіх груп ------------------------

// -------------- Отримує всіх клієнтів  ------------------------
export const getClientsDb = async (colectionName = 'clients', getOrderBy = 'name') => {
  const body = query(
    collection(db, colectionName),
    orderBy(getOrderBy),
    // orderBy(getOrderBy, 'desc'),
  );
  const clientsBdArray = await getDocs(body);
  const clientsArray = [];
  clientsBdArray.forEach((doc) => {
    clientsArray.push(doc.data());
  });

  return clientsArray;
};
// -------------- /Отримує всіх клієнтів ------------------------

// -------------- Змінює доступ до меню (Якщо є в групі то відразу може бачити меню або ні) ------------------------
export const toggleSaveActivityListBD = async (client_id, orSave) => {
  const clientRef = doc(db, 'clients', client_id);
  const userRef = doc(db, 'users', client_id);

  try {
    await updateDoc(clientRef, {
      isAddLoginWebList: orSave,
    });
    await updateDoc(userRef, {
      isAddLoginWebList: orSave,
    });

    return true;
  } catch {
    alert('Не вдалося змінити доступ до групи.');
    return false;
  }
};
// -------------- /Змінює доступ до меню ------------------------

// -------------- Додає клієнта в групу ------------------------
export const addClientGroupBd = async (client_id, groupObject, groupObject_link) => {
  const clientParticipationRef = doc(db, 'clients', client_id);
  const usersParticipationRef = doc(db, 'users', client_id);
  //?
  const loginWebCounterParticipationRef = doc(db, 'loginWebCounter', client_id);
  //?

  const path = 'participationGroups.' + groupObject_link;

  try {
    await updateDoc(clientParticipationRef, {
      [path]: groupObject,
    });
    await updateDoc(usersParticipationRef, {
      [path]: groupObject,
    });
    await updateDoc(loginWebCounterParticipationRef, {
      groupMember: arrayUnion(groupObject.group_id),
    });

    return true;
  } catch {
    alert('Не вдалося додати клієнта до групи.');
    return false;
  }
};
// -------------- /Додає клієнта в групу ------------------------
// -------------- Змінює доступ до меню (Якщо є в групі то відразу може бачити меню або ні) ------------------------
export const toggleGroupAccessAllBD = async (groupId, access) => {
  const groupAccessRef = doc(db, 'groupsList', groupId);

  try {
    await updateDoc(groupAccessRef, {
      groupAccessAll: access,
    });

    return true;
  } catch {
    alert('Не вдалося змінити доступ до групи.');
    return false;
  }
};
// -------------- /Змінює доступ до меню ------------------------

// -------------- Видаляє клієнта з групи ------------------------
export const deleteClientGroupBd = async (client_id, groupObject_link, group_id) => {
  const clientParticipationRef = doc(db, 'clients', client_id);
  const usersParticipationRef = doc(db, 'users', client_id);
  const loginWebCounterParticipationRef = doc(db, 'loginWebCounter', client_id);

  const path = 'participationGroups.' + groupObject_link;

  try {
    await updateDoc(clientParticipationRef, {
      [path]: deleteField(),
    });
    await updateDoc(usersParticipationRef, {
      [path]: deleteField(),
    });
    await updateDoc(loginWebCounterParticipationRef, {
      groupMember: arrayRemove(group_id),
    });
    return true;
  } catch {
    alert('Не вдалося видалити клієнта з групи.');
    return false;
  }
};
// -------------- /Видаляє клієнта з групи ------------------------

// -------------- Надає доступ до меню ------------------------
// addAccessToMenuBd(client_id, groupObject_link, isAccess, group_id);
export const addAccessToMenuBd = async (client_id, groupObject_link, isAccess, group_id) => {
  const clientParticipationRef = doc(db, 'clients', client_id);
  const usersParticipationRef = doc(db, 'users', client_id);

  const path = 'participationGroups.' + groupObject_link + '.accessGroup';

  try {
    await updateDoc(clientParticipationRef, {
      [path]: isAccess,
    });
    await updateDoc(usersParticipationRef, {
      [path]: isAccess,
    });

    return true;
  } catch {
    alert('Не вдалося змінити доступ.');
    return false;
  }
};
// -------------- /Надає доступ до меню ------------------------

// -------------- Міняє дані клієнта ------------------------
export const editsCustomerDataBd = async (client) => {
  try {
    const updateClient = {
      name: client.name,
      surname: client.surname,
      tel: client.tel,
      fullName: client.fullName,
      fromAdvertising: client.fromAdvertising,
      ownСlient: client.ownСlient,
      potentialClient: client.potentialClient,
    };
    await updateDoc(doc(db, 'clients', client.client_id), updateClient);

    const updateName = {
      name: client.name,
      surname: client.surname,
      fullName: client.fullName,
      fromAdvertising: client.fromAdvertising,
    };

    await updateDoc(doc(db, 'measurements', client.client_id), updateName);
    await updateDoc(doc(db, 'loginWebCounter', client.client_id), updateName);
    await updateDoc(doc(db, 'users', client.client_id), updateName);

    return true;
  } catch {
    alert('Не вдалося змінити дані.');
    return false;
  }
};
// -------------- /Міняє дані клієнта ------------------------

// -------------- Міняє нотатки клієнта ------------------------
export const editsClientNotesBd = async (client_id, notesText) => {
  const clientNotesRef = doc(db, 'clients', client_id);

  try {
    await updateDoc(clientNotesRef, {
      notes: notesText,
    });

    return true;
  } catch {
    alert('Не вдалося змінити нотатки.');
    return false;
  }
};
// -------------- /Міняє нотатки клієнта ------------------------
// -------------- Додає дату старту групи ------------------------
export const addDateStartGroupBd = async (group_id, date) => {
  try {
    await setDoc(doc(db, 'groupStartDate', group_id), {
      groupStartDate: date,
    });

    return true;
  } catch {
    alert('Не вдалося змінити дату.');
    return false;
  }
};
// -------------- / Додає дату старту групи------------------------

// -------------- Додає поради ------------------------
export const addTipsBd = async (text) => {
  try {
    await setDoc(doc(db, 'tips', 'tips'), {
      text: text,
    });
    return true;
  } catch {
    return false;
  }
};
export const getTipsBd = async () => {
  const docRef = doc(db, 'tips', 'tips');
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    return docSnap.data();
  } else {
    return false;
  }
};
// -------------- /Додає поради ------------------------

// -------------- Додає контакти ------------------------
export const addContactsBd = async (value) => {
  try {
    await setDoc(doc(db, 'contacts', 'contacts'), value);
    return true;
  } catch {
    return false;
  }
};
export const getContactsBd = async () => {
  const docRef = doc(db, 'contacts', 'contacts');
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    return docSnap.data();
  } else {
    return false;
  }
};
// -------------- /Додає контакти ------------------------

// -------------- Додає дані ------------------------
export const addDocBd = async (collection, document, value) => {
  try {
    await setDoc(doc(db, collection, document), value);
    return true;
  } catch {
    return false;
  }
};
// -------------- /Додає дані ------------------------

// -------------- Видаляє дані ------------------------
export const deleteDocBd = async (collection, id) => {
  try {
    await deleteDoc(doc(db, collection, id));

    return true;
  } catch (e) {
    return false;
  }
};
// -------------- /Видаляє дані ------------------------

// -------------- Отримує дані ------------------------
export const getDocBd = async (collection, document) => {
  const docRef = doc(db, collection, document);
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    return docSnap.data();
  } else {
    return false;
  }
};

export const getDocsOrderByBd = async (colectionName, getOrderBy, byOrder = '') => {
  try {
    const getOrder = (getOrderBy, byOrder) => {
      if (byOrder === 'desc') {
        return orderBy(getOrderBy, 'desc');
      }
      return orderBy(getOrderBy);
    };

    const body = query(
      collection(db, colectionName),
      // orderBy(getOrderBy),
      getOrder(getOrderBy, byOrder),
    );

    const docsBdArray = await getDocs(body);

    const docsArray = [];
    docsBdArray.forEach((doc) => {
      docsArray.push(doc.data());
    });

    return docsArray;
  } catch (e) {
    console.log(e);
    return false;
  }
};

export const getDocsArrayContainsOrderByBd = async (
  colectionName,
  getOrderBy,
  byOrder = '',
  group_id,
) => {
  try {
    const getOrder = (getOrderBy, byOrder) => {
      if (byOrder === 'desc') {
        return orderBy(getOrderBy, 'desc');
      }
      return orderBy(getOrderBy);
    };

    // const body = query(
    //   collection(db, colectionName),
    //   // orderBy(getOrderBy),
    //   getOrder(getOrderBy, byOrder),
    // );

    const body = query(
      collection(db, colectionName),
      where('groupMember', 'array-contains', group_id),
      getOrder(getOrderBy, byOrder),
    );

    const docsBdArray = await getDocs(body);

    const docsArray = [];
    docsBdArray.forEach((doc) => {
      docsArray.push(doc.data());
    });

    return docsArray;
  } catch (e) {
    console.log(e);
    return false;
  }
};
// -------------- /Отримує дані ------------------------

// -------------- Редагує дані ------------------------

export const updateDocBd = async (collection, document_id, item, value) => {
  const clientNotesRef = doc(db, collection, document_id);

  try {
    await updateDoc(clientNotesRef, {
      [item]: value,
    });

    return true;
  } catch {
    return false;
  }
};
// -------------- /Редагує дані ------------------------
